import { render, staticRenderFns } from "./RequirementAdd.vue?vue&type=template&id=282e6ef2&scoped=true&"
import script from "./RequirementAdd.vue?vue&type=script&lang=js&"
export * from "./RequirementAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "282e6ef2",
  null
  
)

export default component.exports